export default {
      id: "file-xls-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#file-xls",
      toString: function () {
        return this.url;
      }
    }